/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import MedicineTimeContainer from '../components/MedicineTime';
import { IoMdAddCircleOutline } from "react-icons/io"
import moment from "moment"
import NameBatchModal from '../components/NameBatchModal';
import UserPreferedTimingContainer from '../components/userPreferedTimings';
import { toast } from 'react-toastify';
import { DAY_PARTS } from '../Constants';
import { BiDuplicate } from "react-icons/bi"
import { MdDelete, MdToday } from "react-icons/md"
import { FiCopy, FiEdit2 } from 'react-icons/fi';
import { TENANT_COMPANY_MAP } from '../../../utils/constants';
import Cookies from "js-cookie";
import Modal from '../../../components/Modal';
import { request } from '../../../config/helpers/axios-instance';
import AddManualDetailsModal from './AddManualDetailsModal';
import { countUserPreferredTimingSlots } from '../../../utils/userPreferredTimingsCount';
import { getMedicineQuantity } from '../../../utils/generateRows';

export default function PrescriptionItem({ updateItem, itemId, Items, userTimings, addItem, deleteItem, order, refetch }) {
    const tenantId = Cookies.get("tenantId");
    const isPillupTenant = tenantId === TENANT_COMPANY_MAP["PILLUP"];
    const isEazyTenant = tenantId === TENANT_COMPANY_MAP["EAZY"];
    const [medicineTimings, setMedicineTimings] = useState({});
    const [showItemmodal, setShowItemModal] = useState(false);
    const [showVerifyDetailsModal, setShowVerifyDetailsModal] = useState(false);
    const [showAddManualDetailsModal, setShowAddManualDetailsModal] = useState(false);
    const [showMdmImageModal, setShowMdmImageModal] = useState(false);
    const [mdmImages, setMdmImages] = useState([]);
    const [selectedDefaultMdmImage, setSelectedDefaultMdmImage] = useState('');
    const [loadingMdmImages, setLoadingMdmImages] = useState(false);
    const [savingMdmImages, setSavingMdmImages] = useState(false);
    const [isEditDetailsMode, setIsEditDetailsMode] = useState(false);
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const itemDetails = Items[itemId]?.item?.itemDetail;
    const pillImages = Items[itemId]?.item?.pillImages;

    const normalizePillImages = (images = []) => {
        if (!images) return [];
        const arr = Array.isArray(images) ? images : [images];
        return arr
            .filter(Boolean)
            .map((img) => ({
                id: img.id || '',
                image: img.image || '',
                url: img.url || '',
                isDefault: Boolean(img.isDefault),
            }))
            .filter((img) => img.image);
    };

    const getDefaultImage = (images = []) => {
        if (!images?.length) return null;
        return images.find((img) => img.isDefault);
    };

    const getStatusChip = () => {
        if (!itemDetails) {
            return { label: 'No Details', className: 'bg-gray-100 text-gray-600' };
        }
        if (itemDetails.status === 'complete' || itemDetails.status === 'verified') {
            return { label: itemDetails.status === 'verified' ? 'Verified' : 'Complete', className: 'bg-green-100 text-green-700' };
        }
        if (itemDetails.status === 'low_score') {
            return { label: 'Low Score', className: 'bg-amber-100 text-amber-700' };
        }
        if (itemDetails.status === 'no_match') {
            return { label: 'No Match', className: 'bg-red-100 text-red-700' };
        }
        return null;
    };

    const statusChip = getStatusChip();

    useEffect(() => {
        let timings = {};
        Items[itemId]?.meal?.map((meal, ind) => {
            timings[ind] = { meal: Items[itemId]?.meal[ind], time: Items[itemId]?.time[ind] }
        })
        setMedicineTimings(timings)
    }, [Items])

    useEffect(() => {
        const normalized = normalizePillImages(pillImages);
        setMdmImages(normalized);
        const defaultImage = getDefaultImage(normalized);
        setSelectedDefaultMdmImage(defaultImage?.id || '');
    }, [pillImages])

    // Check if this item's itemId appears in other prescription items
    const isItemIdUnique = () => {
        const currentItemId = Items[itemId]?.itemId || Items[itemId]?.item?.id;
        if (!currentItemId) return false;

        const itemsWithSameItemId = Object.keys(Items).filter(prescriptionItemId => {
            const otherItemId = Items[prescriptionItemId]?.itemId || Items[prescriptionItemId]?.item?.id;
            return otherItemId === currentItemId;
        });

        // Return true if only this prescription item has this itemId
        return itemsWithSameItemId.length === 1;
    };

    function UpdatePrescriptionItemsApiCall(newTimings) {
        let meal = [], time = [], payLoadData = {};
        Object.keys(newTimings).map((key) => {
            meal.push(newTimings[key].meal);
            time.push(newTimings[key].time);
        })
        payLoadData['meal'] = meal;
        payLoadData['time'] = time;
        updateItem(itemId, { meal, time });
    }

    /**
        * Adds a new medicine time as same as the last one 
    */
    function AddMedicineTiming(time) {
        let newTimings = { ...medicineTimings };
        let size = Object.keys(newTimings).length;
        if (size == 0) {
            if (time) {
                newTimings[0] = { time: time, meal: 'AFTER' }

            }
            else {
                newTimings[0] = { time: "10:00", meal: "AFTER" }
            }
        }
        else {
            if (time) {
                for (let index = 0; index < size; index++) {
                    if (newTimings[index].time === time) {
                        toast.warn('Time is already added!')
                        return;
                    }
                }
                newTimings[parseInt(Object.keys(newTimings)[size - 1]) + 1] = { time: time, meal: 'AFTER' }
            }
            else {
                newTimings[parseInt(Object.keys(newTimings)[size - 1]) + 1] = { ...Object.values(newTimings)[size - 1] }
            }
        }
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings);
    }

    /**
         * Deletes a Medicine time
         * @param id  id which is the index of timing
     */
    function deleteMedicineTiming(id) {
        let newTimings = { ...medicineTimings };
        delete newTimings[id]
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings)
    }

    /**
        * Updates a Medicine time
        * @param id  id of the time to be updated
        * @param name name of the property that has to be updated
        * @param value value to be updated
        * 
    */
    function updateMedicineTiming(id, name, value) {
        let newTimings = { ...medicineTimings };
        newTimings[id][name] = value;
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings);
    }

    const handleCopyMnemonic = () => {
        navigator.clipboard.writeText(Items[itemId]?.item?.mnemonic);
        toast.success("Mnemonic copied to clipboard");
    }


    const setTypeOfAdmin = async (e) => {
        if (e.target.value === 'AS_PER_PRESCRIPTION') {
            setMedicineTimings({})
            await await updateItem(itemId, {
                time: [],
                meal: [],
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                doseSize: 1,
                startDate: order.startDate,
                duration: 1,
                endDate: order.startDate,
                typeOfAdmin: "AS_PER_PRESCRIPTION"
            })
        } else {
            await updateItem(itemId, { [e.target.name]: e.target.value })
        }
    }

    const fetchMdmImages = async ({ openModal = true } = {}) => {
        const medicineId = Items[itemId]?.item?.mnemonic;
        if (!medicineId) {
            toast.error('Mnemonic not found for this item');
            return;
        }

        try {
            setLoadingMdmImages(true);
            const response = await request({
                url: '/item/admin/mdm/images',
                method: 'POST',
                data: { medicineId }
            });

            if (response && response?.data && response.data?.success) {
                await refetch();
                toast.success('Images fetched successfully');
            } else {
                toast.error('Failed to fetch images');
            }

            if (openModal) {
                setShowMdmImageModal(true);
            }

            // const files = response?.data?.files || [];
            // const fetchedImages = files
            //     .map((file) => ({
            //         id: file?.id || file?.imageName || file?.name || '',
            //         image: file?.imageName || file?.name || '',
            //         url: file?.url || '',
            //         isDefault: Boolean(file?.isDefault),
            //     }))
            //     .filter((f) => f.image);

            // if (!fetchedImages.length) {
            //     toast.info('No images found for this medicine');
            //     return;
            // }


        } catch (error) {
            console.error(error);
            toast.error('Failed to fetch images');
        } finally {
            setLoadingMdmImages(false);
        }
    };

    /**
     * Re-request this medicine's images via the queue, for tenants whose MDM cannot accept
     * inbound calls (Eazy). Whatever the agent posts back replaces pillImages wholesale, so the
     * existing images need no clearing first — and if the MDM holds nothing, they stay put.
     *
     * Unlike the PillUp path this is asynchronous: the agent polls roughly once a minute, so
     * nothing appears until the page is reloaded.
     */
    const requestMdmImagesFromAgent = async () => {
        const medicineId = Items[itemId]?.item?.mnemonic;
        if (!medicineId) {
            toast.error('Mnemonic not found for this item');
            return;
        }

        try {
            setLoadingMdmImages(true);
            const response = await request({
                url: '/mdm/requestImages',
                method: 'POST',
                data: { medicineIds: [medicineId] }
            });

            if (response?.data?.success) {
                await refetch();
                setShowMdmImageModal(false);
                toast.success('Images requested. They will appear within a minute — reload the page to see them.');
            } else {
                toast.error('Failed to request images');
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to request images');
        } finally {
            setLoadingMdmImages(false);
        }
    };

    const openMdmImageModal = async () => {
        const existingImages = normalizePillImages(pillImages);
        if (existingImages?.length) {
            setMdmImages(existingImages);
            const defaultImage = getDefaultImage(existingImages);
            setSelectedDefaultMdmImage(defaultImage?.id || '');
            setShowMdmImageModal(true);
            return;
        }

        await fetchMdmImages({ openModal: true });
    };

    const saveMdmImages = async () => {
        if (!selectedDefaultMdmImage) {
            toast.warn('Please select a default image');
            return;
        }

        const medicineId = Items[itemId]?.item?.id;
        if (!medicineId) {
            toast.error('Mnemonic not found for this item');
            return;
        }

        console.log(medicineId)

        try {
            setSavingMdmImages(true);

            const res = await request({
                url: '/item/admin/pillImages/setDefault',
                method: 'PUT',
                data: {
                    id: parseInt(medicineId),
                    imageId: selectedDefaultMdmImage,
                }
            });

            if (res && res?.data && res.data?.success) {
                toast.success('Default image updated successfully');
                setShowMdmImageModal(false);
                refetch?.();
            } else {
                toast.error('Failed to update default image');
                setShowMdmImageModal(false);
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to save default image');
        } finally {
            setSavingMdmImages(false);
        }
    };

    // Images that arrive from the MDM are all saved with isDefault false — a default only
    // exists once an admin picks one in the modal. Fall back to the first so the thumbnail
    // shows up as soon as images land, which is the only preview Eazy gets.
    const defaultMdmImage = getDefaultImage(mdmImages) || mdmImages?.[0];

    return (
        <div className={'flex flex-col rounded-2xl w-full bg-white p-5 gap-2 border-solid shadow-soft-xl ' + (Items[itemId]?.messages?.length > 0 ? " border-2 border-red-300" : "border border-gray-200")} id={`prescriptionItem-${itemId}`}>
            {Items[itemId]?.messages?.map((message, key) => {
                return (
                    <>
                        <div key={key} className='bg-red-50 border border-red-200 rounded-lg p-3'>
                            <p className='text-red-600 text-sm font-medium'>{message.text}</p>
                        </div>
                    </>
                )
            })}

            {/* Header with medicine name and form fields */}
            <div className='flex flex-row flex-wrap items-start justify-between gap-4 mb-3'>
                <div className="flex flex-row gap-2 flex-1">
                    <div className='flex flex-row gap-4 items-center' >
                        <div className='flex flex-col gap-2'>
                            <div className="flex-col gap-1">
                                <div className='flex flex-row gap-2 items-center flex-wrap'>
                                    <h3 className='text-lg font-semibold text-gray-800 max-w-[300px] overflow-hidden whitespace-nowrap'>{Items[itemId]?.item?.name} <br /> <span className='text-xs text-gray-500 p-0 m-0'>{Items[itemId]?.itemBatch?.batch || ''}</span></h3>
                                    <h3 onClick={handleCopyMnemonic} className='text-md text-[purple] font-bold max-w-[200px] overflow-hidden whitespace-nowrap cursor-pointer'>{Items[itemId]?.item?.mnemonic}</h3>
                                    {
                                        tenantId && tenantId === TENANT_COMPANY_MAP["EAZY"] && <FiEdit2 onClick={() => setShowItemModal(true)} />
                                    }
                                    {showItemmodal && <NameBatchModal item={Items[itemId]?.item} onClose={() => setShowItemModal(false)} type='update' prescriptionItemId={itemId} updateItem={updateItem} modalToggle={setShowItemModal} />}

                                    {
                                        tenantId && tenantId === TENANT_COMPANY_MAP["EAZY"] &&
                                        <FiCopy
                                            className="cursor-pointer text-gray-500 hover:text-gray-700 ml-1"
                                            onClick={() => {
                                                navigator.clipboard.writeText(Items[itemId]?.item?.mnemonic);
                                                toast.success("Mnemonic copied to clipboard");
                                            }}
                                            title="Copy mnemonic"
                                        />
                                    }

                                </div>
                            </div>
                            <div className='flex flex-row gap-2 justify-start'>
                                <button
                                    className='p-2 rounded-lg bg-purple-100 text-purple-600 hover:bg-purple-200 transition-colors duration-200'
                                    onClick={() => { addItem(itemId, 'duplicate') }}
                                    title="Duplicate item"
                                >
                                    <BiDuplicate className="text-lg" />
                                </button>
                                <button
                                    className='p-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors duration-200'
                                    onClick={() => { addItem(itemId, 'today'); }}
                                    title="Add for today"
                                >
                                    <MdToday className="text-lg" />
                                </button>
                                {!isItemIdUnique() && (
                                    <button
                                        className='p-2 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition-colors duration-200'
                                        onClick={() => { deleteItem(itemId) }}
                                        title="Delete item"
                                    >
                                        <MdDelete className="text-lg" />
                                    </button>
                                )}
                                {/* On-demand MDM fetch only works for PillUp — Eazy's MDM cannot accept
                                    inbound calls — but any tenant with images already saved should be
                                    able to open the manager and pick a default. */}
                                {(isPillupTenant || mdmImages?.length > 0) && (
                                    <button
                                        className='px-3 py-2 rounded-lg bg-indigo-100 text-indigo-700 hover:bg-indigo-200 transition-colors duration-200 text-xs font-medium'
                                        onClick={openMdmImageModal}
                                        title="Manage medicine images"
                                    >
                                        {loadingMdmImages ? 'Loading...' : 'MDM Images'}
                                    </button>
                                )}
                            </div>
                            {defaultMdmImage?.url && (
                                <div
                                    className='mt-2 cursor-pointer w-fit'
                                    onClick={openMdmImageModal}
                                    title="Click to manage images"
                                >
                                    <img
                                        src={defaultMdmImage.url}
                                        alt={Items[itemId]?.item?.name || 'Medicine image'}
                                        className='h-16 w-16 rounded-lg border border-gray-200 object-contain'
                                    />
                                    <p className='text-[10px] text-gray-500 mt-1'>Default image</p>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Form fields next to medicine name */}
                    {Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' &&
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Start Date</label>
                            <input
                                className='rounded-md h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200'
                                onChange={(e) => { updateItem(itemId, { [e.target.name]: moment(e.target.value).format() }) }}
                                value={moment(Items[itemId]?.startDate).format('YYYY-MM-DD')}
                                name='startDate'
                                type='date'
                            />
                        </div>
                    }
                    {Items[itemId]?.typeOfAdmin !== 'DATE' && Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && (
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Duration</label>
                            <input
                                className='rounded-md h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200'
                                min={1}
                                onChange={(e) => { updateItem(itemId, { [e.target.name]: parseInt(e.target.value) }) }}
                                value={Items[itemId]?.duration}
                                name='duration'
                                type='number'
                            />
                        </div>
                    )}
                    {Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' &&
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>End Date</label>
                            <input
                                className='rounded-md h-10 text-xs px-2 border border-gray-300 bg-gray-50 cursor-not-allowed'
                                disabled
                                value={moment(Items[itemId]?.endDate).format('YYYY-MM-DD')}
                                name='endDate'
                                type='date'
                            />
                        </div>
                    }
                    <div className='flex flex-col'>
                        <label className='text-xs font-medium text-gray-700 mb-1'>Type</label>
                        <select
                            className='rounded-md max-w-[100px] h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200 bg-white'
                            name='typeOfAdmin'
                            value={Items[itemId]?.typeOfAdmin}
                            onChange={setTypeOfAdmin}
                        >
                            <option value="DAYS">Days</option>
                            <option value="DATE">Date</option>
                            <option value="ALTERNATE">Alternate</option>
                            <option value="AS_PER_PRESCRIPTION">As Per Prescription</option>
                        </select>
                    </div>
                    {
                        Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Dose Size</label>
                            <select
                                className='rounded-md max-w-[100px] h-10 text-xs px-1 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200 bg-white'
                                value={Items[itemId]?.doseSize}
                                onChange={(e) => { updateItem(itemId, { 'doseSize': parseFloat(e.target.value) }) }}
                            >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="0.5">0.5</option>
                                <option value="0.25">0.25</option>
                            </select>
                        </div>
                    }

                    {/* Days selector */}
                    {Items[itemId]?.typeOfAdmin === 'DAYS' && (
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Days</label>
                            <div className='flex flex-row gap-1 flex-wrap'>
                                {days.map((day) => {
                                    return (
                                        <button
                                            key={day}
                                            onClick={() => { updateItem(itemId, { [day]: !Items[itemId][day] }) }}
                                            className={`cursor-pointer text-xs rounded-md h-8 w-8 flex items-center justify-center font-medium border transition-all duration-200 ${Items[itemId][day]
                                                ? 'bg-blue-500 text-white border-blue-500'
                                                : 'bg-white text-gray-600 border-gray-300 hover:border-blue-300 hover:bg-blue-50'}`}
                                            title={day.charAt(0).toUpperCase() + day.slice(1)}
                                        >
                                            {day.charAt(0).toUpperCase()}
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
                {/* Status chip and Verify Details button - right aligned */}
                <div className='flex items-center gap-2 flex-shrink-0 ml-auto'>
                    {statusChip && (
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusChip.className}`}>
                            {statusChip.label}
                        </span>
                    )}
                    {itemDetails?.status === 'complete' && (
                        <button
                            className='px-3 py-1.5 rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-200 text-sm font-medium transition-colors duration-200'
                            onClick={() => setShowVerifyDetailsModal(true)}
                        >
                            Verify Details
                        </button>
                    )}
                    {itemDetails?.status === 'verified' && (
                        <button
                            className='px-3 py-1.5 rounded-lg bg-blue-100 text-blue-700 hover:bg-blue-200 text-sm font-medium transition-colors duration-200'
                            onClick={() => setShowVerifyDetailsModal(true)}
                        >
                            View Details
                        </button>
                    )}
                    {(itemDetails?.status === 'low_score' || itemDetails?.status === 'no_match') && (
                        <button
                            className='px-3 py-1.5 rounded-lg bg-amber-100 text-amber-700 hover:bg-amber-200 text-sm font-medium transition-colors duration-200'
                            onClick={() => {
                                setIsEditDetailsMode(false);
                                setShowAddManualDetailsModal(true);
                            }}
                        >
                            Add Details Manually
                        </button>
                    )}
                </div>
            </div>

            {showItemmodal && <NameBatchModal item={Items[itemId]?.item} batchesItem={Items[itemId]?.itemBatches} onClose={() => setShowItemModal(false)} type='update' prescriptionItemId={itemId} updateItem={updateItem} modalToggle={setShowItemModal} />}

            {showVerifyDetailsModal && (
                <Modal title={itemDetails?.status === 'verified' ? 'View Details' : 'Verify Details'} onClose={() => setShowVerifyDetailsModal(false)}>
                    <div className='flex flex-col gap-4'>
                        <pre className='bg-gray-50 rounded-lg p-4 text-sm overflow-auto max-h-[60vh] border border-gray-200'>
                            {itemDetails?.details != null
                                ? (typeof itemDetails.details === 'object'
                                    ? JSON.stringify(itemDetails.details, null, 2)
                                    : itemDetails.details)
                                : 'No details available'}
                        </pre>
                        <div className='flex gap-2'>
                            <button
                                type="button"
                                className='flex-1 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center gap-2'
                                onClick={() => {
                                    setShowVerifyDetailsModal(false);
                                    setIsEditDetailsMode(true);
                                    setShowAddManualDetailsModal(true);
                                }}
                            >
                                <FiEdit2 className="text-base" />
                                Edit
                            </button>
                            {itemDetails?.status === 'verified' ? (
                                <button
                                    type="button"
                                    className='flex-1 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200'
                                    onClick={() => setShowVerifyDetailsModal(false)}
                                >
                                    Close
                                </button>
                            ) : (
                                <button
                                    className='flex-1 py-2 text-white-50 rounded-lg bg-green-500 text-white font-medium hover:bg-green-600 transition-colors duration-200'
                                    onClick={async () => {
                                        if (Items[itemId]?.item?.id) {
                                            await request({
                                                url: `item/admin/verifyItemDetails/${Items[itemId].item.id}`,
                                                method: 'PUT',
                                            })
                                            setShowVerifyDetailsModal(false)
                                            refetch()
                                        }
                                    }}
                                >
                                    Verified
                                </button>
                            )}
                        </div>
                    </div>
                </Modal>
            )}

            {showAddManualDetailsModal && (
                <AddManualDetailsModal
                    itemId={itemId}
                    item={Items[itemId]?.item}
                    isEdit={isEditDetailsMode}
                    onClose={() => setShowAddManualDetailsModal(false)}
                    onSuccess={() => refetch?.()}
                />
            )}

            {showMdmImageModal && (
                <Modal title='Manage MDM Images' onClose={() => setShowMdmImageModal(false)}>
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center justify-between gap-2'>
                            <p className='text-sm text-gray-600'>
                                Select one image as default for this medicine.
                            </p>
                            {/* PillUp's MDM answers inbound calls, so it refetches synchronously.
                                Eazy's sits in hospital infrastructure and only polls us, so the
                                same button queues the request instead. */}
                            <button
                                type='button'
                                className='px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm font-medium transition-colors duration-200'
                                onClick={() => isEazyTenant ? requestMdmImagesFromAgent() : fetchMdmImages({ openModal: false })}
                                disabled={loadingMdmImages}
                                title={isEazyTenant ? 'Ask the MDM machine to send fresh images for this medicine' : 'Fetch fresh images from the MDM'}
                            >
                                {loadingMdmImages ? (isEazyTenant ? 'Requesting...' : 'Refreshing...') : 'Refresh Images'}
                            </button>
                        </div>

                        {mdmImages?.length ? (
                            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 max-h-[65vh] overflow-y-auto'>
                                {mdmImages.map((imageObj) => (
                                    <div
                                        key={imageObj.image}
                                        className={`border-2 rounded-lg p-2 flex flex-col gap-2 cursor-pointer transition-colors duration-150 ${selectedDefaultMdmImage === imageObj.id ? 'border-green-500 bg-green-50' : 'border-gray-200 hover:border-indigo-300'}`}
                                        style={{ height: '280px' }}
                                        onClick={() => setSelectedDefaultMdmImage(imageObj.id)}
                                    >
                                        <div className='flex-1 w-full overflow-hidden rounded-md bg-gray-50' style={{ minHeight: 0 }}>
                                            {imageObj.url ? (
                                                <img
                                                    src={imageObj.url}
                                                    alt={imageObj.image}
                                                    className='w-full h-full object-contain'
                                                />
                                            ) : (
                                                <div className='w-full h-full flex items-center justify-center text-xs text-gray-500 px-2 text-center bg-gray-100'>
                                                    {imageObj.image}
                                                </div>
                                            )}
                                        </div>
                                        <label className='text-xs text-gray-700 flex items-center gap-2 flex-shrink-0 cursor-pointer'>
                                            <input
                                                type='checkbox'
                                                checked={selectedDefaultMdmImage === imageObj.id}
                                                onChange={() => setSelectedDefaultMdmImage(imageObj.id)}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                            Set as default
                                        </label>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className='text-sm text-gray-500'>No images available. Click refresh to fetch images.</p>
                        )}

                        <div className='flex gap-2'>
                            <button
                                type='button'
                                className='flex-1 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200'
                                onClick={() => setShowMdmImageModal(false)}
                                disabled={savingMdmImages}
                            >
                                Cancel
                            </button>
                            <button
                                type='button'
                                className='flex-1 py-2 rounded-lg bg-green-500 text-white-50 font-medium hover:bg-green-600 transition-colors duration-200 disabled:opacity-70'
                                onClick={saveMdmImages}
                                disabled={savingMdmImages || !mdmImages?.length}
                            >
                                {savingMdmImages ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </Modal>
            )}

            {/* Main content area with table and medicine timings */}
            <div className='flex flex-row gap-2 items-start'>
                {/* Invoice table */}
                {Items[itemId]?.invoiceItems?.length > 0 && Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && (() => {
                    const usedQty = getMedicineQuantity(Items[itemId]);
                    const totalBilledQty = Items[itemId].invoiceItems.reduce((acc, i) => acc + (i.quantity || 0), 0);
                    const totalBilledAmt = Items[itemId].invoiceItems.reduce((acc, i) => acc + (i.amount || 0), 0);
                    const showActual = usedQty > 0 && totalBilledQty > 0;
                    const actualAmt = showActual ? (totalBilledAmt / totalBilledQty) * usedQty : null;
                    return (
                        <div className='bg-gray-50 rounded-lg flex-shrink-0'>
                            <div className="overflow-x-auto">
                                <table className="min-w-full">
                                    <thead>
                                        <tr className="border-b border-gray-200">
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Batch</th>
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Expiry</th>
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>MRP</th>
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Qty</th>
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Disc(₹)</th>
                                            <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Amount(₹)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Items[itemId].invoiceItems.map((invoiceItem, index) => {
                                            return <tr key={invoiceItem?.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                <td className='text-xs font-medium text-gray-700 py-1 px-2'>{invoiceItem?.batch || 'NA'}</td>
                                                <td className='text-xs text-gray-600 py-1 px-2'>{moment(invoiceItem?.expireDate).format("MM/YY") || 'NA'}</td>
                                                <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.mrp?.toFixed(2) || 'NA'}</td>
                                                <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.quantity || 'NA'}</td>
                                                <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.discount?.toFixed(2) || 'NA'}</td>
                                                <td className='text-xs font-medium text-gray-800 py-1 px-2'>{invoiceItem?.amount?.toFixed(2) || 'NA'}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {showActual && (
                                <div className='flex items-center gap-1 px-2 py-1 border-t border-gray-200'>
                                    <span className='text-xs text-orange-500 font-medium'>Actual Amt(₹):</span>
                                    <span className='text-xs text-orange-600 font-semibold'>{actualAmt.toFixed(2)}</span>
                                    <span className='text-xs text-gray-400'>({usedQty} used of {totalBilledQty})</span>
                                </div>
                            )}
                        </div>
                    );
                })()}

                {/* Medicine timing section - using remaining space */}
                {medicineTimings && Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && (
                    <div className='flex-1'>
                        <div className='flex flex-col gap-3'>
                            <div className='flex flex-col'>
                                <span className='text-xs text-gray-500 mb-2'>Quick Add</span>
                                <div className='flex flex-row flex-wrap gap-2'>
                                    {countUserPreferredTimingSlots(userTimings) > 0 && userTimings ? (
                                        DAY_PARTS.map((key, index) => {
                                            if (Object.prototype.hasOwnProperty.call(userTimings, key)) {
                                                if (key === 'CUSTOM') {
                                                    return userTimings[key].map((timing) => {
                                                        return <UserPreferedTimingContainer key={index} dayPart={key} time={timing} AddMedicineTiming={AddMedicineTiming} />
                                                    })
                                                }
                                                return <UserPreferedTimingContainer key={index} dayPart={key} time={userTimings[key]} AddMedicineTiming={AddMedicineTiming} />
                                            }
                                        })
                                    ) : (
                                        <>
                                            <UserPreferedTimingContainer
                                                key="preset-9am"
                                                dayPart="BREAKFAST"
                                                time="09:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                            />
                                            <UserPreferedTimingContainer
                                                key="preset-2pm"
                                                dayPart="LUNCH"
                                                time="14:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                            />
                                            <UserPreferedTimingContainer
                                                key="preset-9pm"
                                                dayPart="DINNER"
                                                time="21:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <div className='flex flex-row flex-wrap items-center justify-start gap-2'>
                                    {Object.keys(medicineTimings)?.map((key) => {
                                        return (<MedicineTimeContainer updateMedicineTiming={updateMedicineTiming} deleteMedicineTiming={deleteMedicineTiming} ind={key} key={key} timing={medicineTimings[key]} />)
                                    })}
                                    <button
                                        className='p-2 rounded-lg border-2 border-dashed border-blue-300 text-blue-500 hover:border-blue-500 hover:bg-blue-50 transition-all duration-200'
                                        onClick={() => { AddMedicineTiming() }}
                                        title="Add timing"
                                    >
                                        <IoMdAddCircleOutline className='text-2xl' />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    )
}
